module.exports = __webpack_public_path__ + "static/loadperfwarning-2a5f929f789b2f62ede2c88c593a1779.png";